<template>
  <div class="allwidth">
    <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item @click="downchange(4)">
        <el-image :src="url" style="width: 248px;height: 52px;"></el-image>
      </el-menu-item>
      <!-- <el-menu-item index="4">订单管理</el-menu-item> -->
      <el-menu-item style="float: right;">

        <el-dropdown @command="downchange">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid"></i>
            <i class="el-icon-caret-bottom"></i>

          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">个人中心</el-dropdown-item>
            <el-dropdown-item command="2">我的教学</el-dropdown-item>
            <el-dropdown-item command="3">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu-item>
      <el-menu-item style="float: right;">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">

          <el-select v-model="select" slot="prepend" placeholder="请选择" @change="selectchange">
            <el-option label="课程" value="1"></el-option>
            <el-option label="培训" value="2"></el-option>
          </el-select>

          <el-button type="success" size="mini" slot="suffix" @click="gosearch()">搜索</el-button>
        </el-input>
      </el-menu-item>

    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'headers',
    data() {
      return {
        select: '课程',
        selectList: ['','课程','培训'],
        url: require('../assets/logo.png'),
        input3: '',
        // activeIndex: '/courseware',
        activeIndex2: '1',
        type:1
      }
    },
    props: {
      activeIndex: String,
    },
    methods: {
      handleSelect(){

      },
      selectchange(event) {
        this.type=event
        console.log(event)
      },
      downchange(event) {
        console.log(event)
        if (event == 1) {
          this.$router.push({
            name: 'personage'
          })
        } else if (event == 2) {
          this.$router.push({
            name: 'homework'
          })
        } else if (event == 3) {
          window.localStorage.clear()
          this.$router.push({
            name: 'home'
          })
          location.reload()
        }else if (event == 4) {
          this.$router.push({
            name: 'courseware'
          })
        }
      },
      gosearch() {
        if (this.input3.length >= 2) {
          this.$router.push({
            name: 'search',
            query: {
              keyword: this.input3,
              type:this.type
            }
          })
        } else {
          this.$message({
            message: '关键词不能少于两个',
            type: 'warning'
          });
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .allwidth {
    width: 100%;
    border-bottom: 1px solid #E3E9FF;
    background-color: #fff;
  }

  .el-header,
  .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 52px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    height: 52px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .el-select .el-input {
    width: 110px !important;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-input-group__append {
    background-color: #22AC38;
    color: #FFFFFF;
    width: 52px !important;
    height: 28px !important;
    background: #22AC38;
    border-radius: 5px 5px 5px 5px;
    padding: 0;
    overflow: hidden;
  }

  .el-input__suffix {
    display: flex;
  }

  .el-input__suffix-inner {
    align-self: center;
  }

  .el-input-group {
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #22AC38;
    overflow: hidden;
  }

  .el-menu {
    width: 100%;
    max-width: 1290px;
    margin: 0 auto;
    border: none !important;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none !important;
    /* border-top: 4px solid #57BC4C; */
    line-height: 56px;
    position: relative;
    overflow: hidden !important;

  }
  .el-menu--horizontal>.el-menu-item.is-active::before{
    content:"";
    display: block;
    width: 62%;
    height: 4px;
    background: #57BC4C;
    position: absolute;
    top: 0px;
  }

  .el-menu--horizontal>.el-menu-item{font-size:16px;color:#666666;font-weight: 400;}
  /* .el-menu li{font-size: 20px !important;}
  .el-menu--horizontal>.el-submenu .el-submenu__title{font-size: 20px;} */
</style>



// WEBPACK FOOTER //
// src/components/headers.vue